import { Component, OnInit, ViewChild, Output, EventEmitter, Input, Self } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ToastService, MdbCheckboxChange } from 'ng-uikit-pro-standard';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { RuteadorService } from 'src/app/services/ruteador.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { ModalClonarRecorridoComponent } from '../modal-clonar-recorrido/modal-clonar-recorrido.component';
import { ModalAddEditRutasComponent } from '../modal-add-edit-ruta/modal-add-edit-ruta.component';

enum QUERY_TYPE {
  ONLY_RUTEADOR_MANUAL = 'RUTEADOR_MANUAL',
  ONLY_RUTEADOR = 'RUTEADOR',
}

@Component({
  selector: 'ruteador-modal-asignar',
  templateUrl: './modal-asignar.component.html',
  styleUrls: ['../ruteador.component.scss'],
  providers: [SecurityService],
})
export class RuteadorModalAsignarComponent implements OnInit {
  @Output() onActualizarListaChoferes: EventEmitter<void> = new EventEmitter<void>();
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();
  @Output() onShowModalRutasRequest: EventEmitter<void> = new EventEmitter<void>();
  @Output() onUpdateEditar: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(ModalClonarRecorridoComponent, { static: true }) onShowModalClonarRuta: ModalClonarRecorridoComponent;
  @ViewChild(ModalAddEditRutasComponent, { static: true }) verAddEditRutasModal: ModalAddEditRutasComponent

  @ViewChild('asignarCamionRutas', { static: true }) asignarCamionRutas: ModalDirective;
  private eventsSubscription: Subscription;
  @Input() events: Observable<void>;
  @Input() queryType: QUERY_TYPE = QUERY_TYPE.ONLY_RUTEADOR;
  onlyRuteador: Boolean = false;

  // Modales
  @ViewChild('asignarCamionRutas', { static: true }) modalAsignarCamionRutas: ModalDirective;
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent;

  private rutEmpresa: number;
  private sucursalCodigo: number;

  private currentPayload: any;
  private lastIndexChecked: number = -1;

  processing: boolean = false
  loading: boolean = false;
  listadoCamionChofer: Array<any> = null;
  listadoCamionChoferDisponible: Array<any> = null;
  listadoCamionChoferDisponibleAll: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext();

  documentosRecorridos: Array<any> = [];
  beachesSeleccionados = [];
  edicionRecorrido: boolean = false;

  recorridoDetalle: Array<any> = [];
  recorridoDetalleAsignados: Array<any> = [];

  private client: GraphQLClient = null;
  asignar: boolean;

  constructor(
    private accesolocalstorage: SecurityService,
    private toastService: ToastService,
    private recorridoService: RecorridoService,
    private messageRendererService: MessageRendererService,
    private _ruteadorService: RuteadorService,
    client: GraphQLClient
  ) {
    this.client = client;
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.paginationContext.RecordsByPage = 10;

    //this.eventsSubscription = this.events.subscribe(() => this.obtenerChoferesDisponibles());
  }

  ngOnDestroy() { }

  show(beachesSeleccionados, documentosRecorridos, listadoCamionChofer, unidad_negocio_codigo: number, fecha, editar: boolean = false) {
    this.clearAll();
    this.beachesSeleccionados = beachesSeleccionados;
    this.documentosRecorridos = documentosRecorridos;
    this.listadoCamionChofer = listadoCamionChofer
    this.edicionRecorrido = editar;
    this.currentPayload = {
      unidad_negocio_codigo,
      fecha,
      rutEmpresa: this.rutEmpresa,
      paginaActual: 1,
      cantidadRegistrosPorPagina: -1,
      editar,
    };

    this.obtenerChoferesDisponibles();
    this.modalAsignarCamionRutas.show();
  }

  clearAll() {
    this.loading = true;
    this.listadoCamionChoferDisponibleAll = [];
    this.listadoCamionChoferDisponible = [];
    this.lastIndexChecked = -1;
  }

  obtenerChoferesDisponibles() {
    // var fecha = "09-09-2020"
    const self = this;
    const inputParams = this.currentPayload;

    this._ruteadorService.obtenerCamionChoferDisponible(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros } = respuesta;

      this.listadoCamionChoferDisponibleAll = registros;

      if (this.listadoCamionChoferDisponibleAll.length == 0) {
        this.listadoCamionChoferDisponibleAll = [];
        this.toastService.warning('No existen Rutas a la fecha');
      }

      // this.listadoCamionChoferDisponibleAll = _.sortBy(this.listadoCamionChoferDisponibleAll, ['recorrido_codigo'], ['desc'])

      this.paginationContext.RecordsCount = this.listadoCamionChoferDisponibleAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      // this.paginationContext.CurrentPage = 1

      this.listadoCamionChoferDisponibleAll.forEach((mov, index) => {
        mov.checked = false;
        mov.index = index;
        const foundElement = this.listadoCamionChofer.find(x => x.recorrido_codigo == mov.recorrido_codigo);
        mov.color = foundElement ? foundElement.color : ''
      });

      // let response = respuesta.data.ruteador.obtenerCamionChoferDisponible.respuesta.registros;
      //   response.forEach((element) => {
      //     self.listadoCamionChoferDisponible.push(
      //       {
      //         patente: element.patente,
      //         chofer_rut: element.chofer_rut,
      //         recorrido_codigo: element.recorrido_codigo,
      //         descripcion_camion: element.descripcion_camion,
      //         checked: false
      //       }
      //     );
      //   });

      this.showPage(this.paginationContext.CurrentPage);
      this.loading = false;
    });

    // this.client.query(
    //   {
    //     query: gql`
    //       query(
    //         $fecha: String
    //       ) {
    //         ruteador {
    //           obtenerCamionChoferDisponible(fecha: $fecha) {
    //           respuesta {
    //             registros {
    //               patente
    //               chofer_rut
    //               recorrido_codigo
    //               descripcion_camion
    //               fecha
    //               nombre_chofer
    //               total_facturas
    //             }
    //           }
    //         }
    //       }
    //       }
    //     `,
    //     fetchPolicy: 'no-cache',
    //     variables: inputParams,
    //   },
    //   function (respuesta) {

    //     self.listadoCamionChoferDisponible = []

    //     let response = respuesta.data.ruteador.obtenerCamionChoferDisponible.respuesta.registros;
    //     response.forEach((element) => {
    //       self.listadoCamionChoferDisponible.push(
    //         {
    //           patente: element.patente,
    //           chofer_rut: element.chofer_rut,
    //           recorrido_codigo: element.recorrido_codigo,
    //           descripcion_camion: element.descripcion_camion,
    //           checked: false
    //         }
    //       );
    //     });
    //   }
    // );
  }

  checkItem(camChofDisp, event: MdbCheckboxChange) {
    const { checked } = event;

    const { index } = camChofDisp;

    // mainReg.checked = !currentCheck
    if (!this.edicionRecorrido) {
      // get main record
      const mainReg = this.listadoCamionChoferDisponibleAll.find((reg) => reg.index === index);
      const currentCheck = mainReg.checked;

      // uncheck all
      this.listadoCamionChoferDisponibleAll.forEach((reg) => {
        reg.checked = false;
      });

      if (index === this.lastIndexChecked) {
        mainReg.checked = true;
      } else {
        mainReg.checked = !currentCheck;
      }

      event.element.checked = mainReg.checked;

      this.lastIndexChecked = index;
    } else {
      const selectedMain: any = this.listadoCamionChoferDisponibleAll.filter((p) => p.recorrido_codigo === camChofDisp.recorrido_codigo)[0];
      selectedMain.checked = checked;

      this.listadoCamionChoferDisponible.map((detalle) => {
        if (detalle.recorido_codigo === camChofDisp.recorrido_codigo) {
          detalle.checked = checked;
        }
      });
    }

    // const pagedReg = this.listadoCamionChoferDisponible.find(reg => reg.index === index)
    // pagedReg.checked = !pagedReg.checked;
    this.showPage(this.paginationContext.CurrentPage);

    // this.SoloUnCheck(camChofDisp)
  }

  // get selected() {
  //   return this.listadoCamionChoferDisponibleAll.find(p => p.index === this.lastIndexChecked)
  // }

  // SoloUnCheck(camionseleccionado: any) {
  //   const self = this;

  //   var camAux = self.listadoCamionChoferDisponible

  //   self.listadoCamionChoferDisponible = []

  //   camAux.forEach((element) => {
  //     if (element.recorrido_codigo === camionseleccionado.recorrido_codigo) {
  //       self.listadoCamionChoferDisponible.push(
  //         {
  //           patente: element.patente,
  //           chofer_rut: element.chofer_rut,
  //           recorrido_codigo: element.recorrido_codigo,
  //           checked: true
  //         }
  //       );
  //     } else {
  //       self.listadoCamionChoferDisponible.push(
  //         {
  //           patente: element.patente,
  //           chofer_rut: element.chofer_rut,
  //           recorrido_codigo: element.recorrido_codigo,
  //           checked: false
  //         }
  //       );
  //     }
  //   });
  // }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.listadoCamionChoferDisponible = _.slice(this.listadoCamionChoferDisponibleAll, start, start + this.paginationContext.RecordsByPage);
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  //ABRIR MODAL DE CLONAR RECORRIDO
  ClonarRecorrido() {
    const selectFilter = this.listadoCamionChoferDisponibleAll.filter((x) => x.checked == true);


    // Validación detallada para verificar el estado del chofer y camión
    const choferesInactivos = selectFilter.filter((item) => !item.chofer_activo).map((item) => item.nombre_chofer.trim());
    const camionesInactivos = selectFilter.filter((item) => !item.camion_activo).map((item) => item.descripcion_camion.trim());

    if (choferesInactivos.length > 0 && camionesInactivos.length > 0) {
      this.showWarning(`Los choferes ${choferesInactivos.join(', ')} y los camiones ${camionesInactivos.join(', ')} seleccionados no están activos.`);
      return;
    } else if (choferesInactivos.length > 0) {
      this.showWarning(`Los choferes ${choferesInactivos.join(', ')} seleccionados no están activos.`);
      return;
    } else if (camionesInactivos.length > 0) {
      this.showWarning(`Los camiones ${camionesInactivos.join(', ')} seleccionados no están activos.`);
      return;
    }

    this.onShowModalClonarRuta.show(selectFilter);
  }

  AsignarCamion() {
    const listado = this.listadoCamionChoferDisponible.filter((p) => p.checked);
    this.clearRecorridoSeleccionado();
    this.beachesSeleccionados;
    this.processing = true

    const self = this;
    self.asignar = false;

    if (listado.length === 0) {
      this.showInfo('Seleccione un recorrido');
      self.processing = false
      return;
    }

    //  SELECCIONAR EL RUTEADOR PARA REALIZAR LA BUSQUEDA DE INFORMACION
    switch (self.queryType) {
      case QUERY_TYPE.ONLY_RUTEADOR:
        {
          self.ruteadorMap(listado);
        }
        break;
      case QUERY_TYPE.ONLY_RUTEADOR_MANUAL:
        {
          self.ruteadorManual(listado);
        }
        break;

      default:
        self.ruteadorMap(listado);
        break;
    }

    // debugger;
    if (self.asignar) {
      var bodyx = this.recorridoDetalle;

      self.client.mutate(
        {
          mutation: gql`
            mutation ($entidad: lista_recorrido_detalleInputType) {
              recorrido_detalle {
                agregarListaRecorridoDetalle(entidad: $entidad) {
                  respuesta {
                    recorrido_codigo
                    status
                    message
                  }
                  mensajes {
                    codigo
                    contexto
                    texto
                    tipo
                  }
                }
              }
            }
          `,
          variables: {
            entidad: {
              objet: bodyx,
            },
          },
        },
        function (respuesta) {
          const ok = respuesta !== null;
          self.processing = false

          if (respuesta.data.recorrido_detalle.agregarListaRecorridoDetalle.respuesta === null) {
            self.showError('Ha ocurrido un problema en la asignación. ' + respuesta.data.recorrido_detalle.agregarListaRecorridoDetalle.mensajes.texto);
            self.recorridoDetalle = [];
            return;
          }

          if (!ok) {
            self.showError('Ha ocurrido un problema en la asignación. ' + respuesta.data.recorrido_detalle.agregarListaRecorridoDetalle.respuesta.message);
            self.recorridoDetalle = [];
            return;
          }

          if (respuesta.data.recorrido_detalle.agregarListaRecorridoDetalle.respuesta.status == 'NOK') {
            self.showInfo(
              'El camión se encuentra con . ' + respuesta.data.recorrido_detalle.agregarListaRecorridoDetalle.respuesta.message + ' La asignación de documento(s) al camión se ha realizado con éxito.'
            );

            self.modalAsignarCamionRutas.hide();
          }

          if (respuesta.data.recorrido_detalle.agregarListaRecorridoDetalle.respuesta.status == 'OK') {
            self.showSuccess('La asignación de documento(s) al camión ha sido realizada con éxito.');
            self.modalAsignarCamionRutas.hide();
          }

          // setTimeout(() => self.ObtenerCamiones(this.filtroFecha), 1000);
          // setTimeout(() => self.obtenerResumenDocumentos(), 1000);
          // setTimeout(() => self.obtenerDocumentosRecorrido(self.rutEmpresa), 1000);

          //LIMPIAR ARREGLO
          self.recorridoDetalle.splice(0, self.recorridoDetalle.length);
          self.onSuccess.emit();
        }
      );
    } else {
      this.showInfo('Seleccione un Documento');
      self.processing = false
      return;
    }
  }

  ruteadorManual(listado) {
    const self = this;
    var flag = false;

    self.documentosRecorridos.forEach((element1) => {
      self.beachesSeleccionados.forEach((element2) => {
        if (element1.latitud.trim() === element2.latitud.trim()) {
          if (element1.additionalInfo.checked === true) {
            this.recorridoDetalle.push({
              recorrido_codigo: listado[0].recorrido_codigo,
              vendedor_codigo: element1.vendedor_codigo, //
              rut_emisor: element1.rut_emisor, //
              folio: element1.folio, //
              tipo_dte_codigo: element1.tipo_dte_codigo, //
              ruta_codigo: element1.ruta_codigo,
              cliente_proveedor_rut: element1.cliente_proveedor_rut,
              direccion_codigo: element1.direccion_codigo,
              monto_documento: 0, //lstCamChof[0].total_facturas
            });
          }
        }
      });
    });

    for (var i = 0; i < this.recorridoDetalle.length; i++) {
      delete this.recorridoDetalle[i]['__typename'];
    }

    if (!flag && this.recorridoDetalle.length > 0) {
      this.asignar = true;
    } else if (flag) {
      this.showWarning('Ha seleccionado documentos que ya se encuentra(n) asignado(s)');
      this.recorridoDetalle.splice(0, this.recorridoDetalle.length);
    }
  }

  ruteadorMap(listado) {
    const self = this;

    var flag = false;

    self.documentosRecorridos.forEach((element1) => {
      self.beachesSeleccionados.forEach((element2) => {
        if (element1.latitud.trim() === element2.latitud.trim()) {
          if (element1.folio_recorrido_Detalle > 0) {
            this.recorridoDetalleAsignados.push({
              recorrido_codigo: listado[0].recorrido_codigo,
              vendedor_codigo: element1.vendedor_codigo, //
              rut_emisor: element1.rut_emisor, //
              folio: element1.folio, //
              tipo_dte_codigo: element1.tipo_dte_codigo, //
              ruta_codigo: element1.ruta_codigo,
              cliente_proveedor_rut: element1.cliente_proveedor_rut,
              direccion_codigo: element1.direccion_codigo,
              monto_documento: 0, //lstCamChof[0].total_facturas
            });
            //flag = true;
          } else {
            this.recorridoDetalle.push({
              recorrido_codigo: listado[0].recorrido_codigo,
              vendedor_codigo: element1.vendedor_codigo, //
              rut_emisor: element1.rut_emisor, //
              folio: element1.folio, //
              tipo_dte_codigo: element1.tipo_dte_codigo, //
              ruta_codigo: element1.ruta_codigo,
              cliente_proveedor_rut: element1.cliente_proveedor_rut,
              direccion_codigo: element1.direccion_codigo,
              monto_documento: 0, //lstCamChof[0].total_facturas
            });
          }
        }
      });
    });

    for (var i = 0; i < this.recorridoDetalle.length; i++) {
      delete this.recorridoDetalle[i]['__typename'];
    }

    if (!flag && this.recorridoDetalle.length > 0) {
      this.asignar = true;
    } else if (flag) {
      this.showWarning('Ha seleccionado documentos que ya se encuentra(n) asignado(s)');
      this.recorridoDetalle.splice(0, this.recorridoDetalle.length);
    }
  }

  editarRecorrido(recorrido: any): void {
    // console.log('=>(modal-asignar.component.ts:372) recorrido', recorrido);
    // this.recorridoService.recorridoSeleccionado$.emit(recorrido);
    // this.onShowModalRutasRequest.emit();
    this.verAddEditRutasModal.showEdit(recorrido);
  }

  onCargarRuta() {
    this.obtenerChoferesDisponibles();
    this.onActualizarListaChoferes.emit();
  }

  confirmEliminar(recorrido: any) {
    const self = this;

    const title = 'Eliminar';
    const message = '¿Está seguro de eliminar registro?';

    this.modalConfirm.showWithInlineConfig(title, message, () => {
      const _recorrido = _.cloneDeep(recorrido);
      delete _recorrido.__typename;
      const inputParams = {
        entidad: {
          chofer_rut: recorrido.chofer_rut,
          codigo: recorrido.recorrido_codigo,
          camion_patente: recorrido.patente,
          sucursal_codigo: this.sucursalCodigo,
          rut_empresa: this.rutEmpresa,
          activo: recorrido.checked,
          //unidad_negocio: this.formRuta.get('negocio').value
        },
      };
      this.recorridoService.eliminar(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }
        this.toastService.success('Operación realizada');
        this.onCargarRuta();
      });
      // setTimeout(() => this.buscarPorFiltros(), 1000);
    });
    this.onCargarRuta();
  }

  showWarning(mensaje) {
    const options = { opacity: 1 };
    this.toastService.warning(mensaje, 'Mensaje Advertencia!', options);
  }

  showInfo(mensaje) {
    const options = { opacity: 1 };
    this.toastService.info(mensaje, 'Mensaje Información!', options);
  }

  showSuccess(mensaje) {
    const options = { opacity: 1 };
    this.toastService.success(mensaje, 'Mensaje Éxito!', options);
  }

  showError(mensaje) {
    const options = { opacity: 1 };
    this.toastService.error(mensaje, 'Mensaje Error!', options);
  }

  requestShowModalRutas() {
    this.clearRecorridoSeleccionado();
    //this.onShowModalRutasRequest.emit();
    this.verAddEditRutasModal.showAdd();
  }
  clearRecorridoSeleccionado(): void {
    this.recorridoService.recorridoSeleccionado$.emit(null);
  }

  UpdateEditarRutas() {
    this.obtenerChoferesDisponibles();
  }

  cerrarModal(): void {
    this.clearRecorridoSeleccionado();
    this.asignarCamionRutas.hide();
  }
}
